<template>
    <div class="ml-column">
        <div class="head">
            <span class="title"> {{ title }} </span>
            <router-link :to="more" v-if="more != ''" class="more">
                更多>>>
            </router-link>
        </div>
        <div>
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: ""
        },
        more: {
            type: String,
            default: ""
        }
    }
};
</script>

<style lang="scss" scoped>
.ml-column {
    position: relative;
    width: 100%;
    margin-top: 20px;

    .head {
        padding-bottom: 3px;
        border-bottom: 2px solid $ml-blue;
        margin-bottom: 20px;

        .title {
            font-size: 20px;
            letter-spacing: 3px;
        }

        .more {
            margin-top: 10px;
            font-size: 12px;
            float: right;
            color: #666;
        }
    }
}
</style>
